
const TestimonialsSection = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Sarah Mitchell',
      role: 'Verified User',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20young%20woman%20with%20brown%20hair%20smiling%20warmly%2C%20clean%20white%20background%2C%20high%20quality%20photography%2C%20natural%20lighting&width=100&height=100&seq=avatar001&orientation=squarish',
      rating: 5,
      text: 'Ohprice saved me over $500 on my new laptop! The price alerts are incredibly accurate and I never miss a deal anymore.',
      platform: 'Trustpilot',
      savings: '$500+'
    },
    {
      id: 2,
      name: 'Michael Chen',
      role: 'Verified User',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20an%20asian%20man%20in%20his%2030s%20with%20glasses%20smiling%2C%20clean%20white%20background%2C%20high%20quality%20photography%2C%20natural%20lighting&width=100&height=100&seq=avatar002&orientation=squarish',
      rating: 5,
      text: 'The price history feature is a game-changer. I can see exactly when to buy and when to wait. Highly recommend!',
      platform: 'Google',
      savings: '$320+'
    },
    {
      id: 3,
      name: 'Emily Rodriguez',
      role: 'Verified User',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20latina%20woman%20with%20dark%20hair%20smiling%20confidently%2C%20clean%20white%20background%2C%20high%20quality%20photography%2C%20natural%20lighting&width=100&height=100&seq=avatar003&orientation=squarish',
      rating: 5,
      text: 'I love how easy it is to compare prices across different stores. The interface is clean and the alerts are timely.',
      platform: 'Trustpilot',
      savings: '$180+'
    }
  ];

  const renderStars = (rating: number) => {
    return (
      <div className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map(star => (
          <i
            key={star}
            className={`text-sm ${star <= rating ? 'ri-star-fill text-amber-400' : 'ri-star-line text-gray-300'}`}
          ></i>
        ))}
      </div>
    );
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-sm font-semibold text-teal-600 uppercase tracking-wider">Testimonials</span>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mt-3 mb-4">
            Loved by Smart Shoppers
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Join thousands of users who save money every day with Ohprice.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-gray-50 rounded-2xl p-6 hover:shadow-lg transition-shadow"
            >
              {/* Rating */}
              <div className="flex items-center justify-between mb-4">
                {renderStars(testimonial.rating)}
                <span className="px-3 py-1 bg-green-100 text-green-700 text-xs font-medium rounded-full">
                  Saved {testimonial.savings}
                </span>
              </div>

              {/* Quote */}
              <div className="mb-6">
                <i className="ri-double-quotes-l text-3xl text-teal-200"></i>
                <p className="text-gray-700 leading-relaxed mt-2">
                  {testimonial.text}
                </p>
              </div>

              {/* Author */}
              <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                <div className="flex items-center gap-3">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  <div>
                    <p className="font-semibold text-gray-900">{testimonial.name}</p>
                    <div className="flex items-center gap-1 text-xs text-gray-500">
                      <i className="ri-verified-badge-fill text-green-500"></i>
                      {testimonial.role}
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-1 text-xs text-gray-400">
                  <i className={testimonial.platform === 'Google' ? 'ri-google-fill' : 'ri-star-fill text-green-500'}></i>
                  {testimonial.platform}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badges */}
        <div className="mt-16 flex flex-wrap items-center justify-center gap-8 lg:gap-16">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <i className="ri-shield-check-fill text-green-600 text-xl"></i>
            </div>
            <div>
              <p className="font-semibold text-gray-900">100% Free</p>
              <p className="text-sm text-gray-500">No hidden fees</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center">
              <i className="ri-lock-fill text-teal-600 text-xl"></i>
            </div>
            <div>
              <p className="font-semibold text-gray-900">Secure & Private</p>
              <p className="text-sm text-gray-500">Your data is safe</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
              <i className="ri-customer-service-2-fill text-amber-600 text-xl"></i>
            </div>
            <div>
              <p className="font-semibold text-gray-900">24/7 Support</p>
              <p className="text-sm text-gray-500">Always here to help</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
